import { h } from '@stencil/core/internal/client';
import { b as bem } from './bem.js';
import { h as hasNamedSlot, a as getNamedSlotTextContent } from './slot-utils.js';

const FormField = ({ helpText, appearance = 'dark', disabled, label, invalid, labelForValue, requiredLabel, optionalLabel, validationMessage, class: classname, element, required, }, children) => {
    const generateClassNames = bem('cosmos-form-field');
    const requiredOrOptionalLabel = required ? requiredLabel : optionalLabel;
    const handleLabelClick = () => {
        const target = element.shadowRoot.querySelector(`#${labelForValue}`);
        if (target === null || target === void 0 ? void 0 : target.hasAttribute('role')) {
            target.focus();
        }
    };
    const getHelpText = () => {
        if (helpText) {
            return helpText;
        }
        if (hasNamedSlot(element, 'help-text')) {
            return getNamedSlotTextContent(element, 'help-text');
        }
    };
    return (h("div", { class: [
            classname,
            generateClassNames({
                invalid,
                disabled,
                appearance,
            }),
        ].join(' '), part: "base" },
        (label || requiredOrOptionalLabel) && (h("div", { class: generateClassNames('info-container') },
            h("label", { htmlFor: labelForValue !== null && labelForValue !== void 0 ? labelForValue : undefined, class: generateClassNames('label'), onClick: handleLabelClick },
                h("cosmos-text", { appearance: appearance, class: generateClassNames('label-text'), exportparts: "base: label", size: "x-small", tag: "span", weight: "medium" },
                    h("span", { id: "label" }, label)),
                requiredOrOptionalLabel && (h("cosmos-text", { appearance: appearance, "aria-hidden": "true", class: generateClassNames('required-optional-label'), exportparts: "base: required-label", kind: "subtle", size: "xx-small", tag: "span" }, requiredOrOptionalLabel))),
            h("cosmos-text", { appearance: appearance, class: generateClassNames('help-text'), kind: "subtle", size: "x-small", exportparts: "base: help-text" },
                h("span", { "aria-label": getHelpText(), id: "help-text" },
                    h("slot", { name: "help-text" }, helpText))))),
        h("div", null, children),
        h("div", { "aria-live": "polite" // Announce the validation message in a non-interruptive way
            , "aria-atomic": "true" // Announce the validation message in its entirety
            , class: generateClassNames('validation-message-container') }, invalid && validationMessage && (h("div", { class: generateClassNames('validation-message') },
            h("cosmos-icon-warning", { class: generateClassNames('validation-message-icon') }),
            h("cosmos-text", { appearance: appearance, class: generateClassNames('validation-message-text'), exportparts: "base: validation-message", size: "x-small", tag: "span" },
                h("span", { id: "validation-message" }, validationMessage)))))));
};

export { FormField as F };
